import { render } from "./AltarServerCreateEditModal.vue?vue&type=template&id=3d8cec1c"
import script from "./AltarServerCreateEditModal.vue?vue&type=script&lang=js"
export * from "./AltarServerCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__